import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';

const VisionCriteria1 = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    browsingFilterStore: { getFilterRangeValue, onRangeFilterChange },
  } = useRootStore();
  const filterName = 'Frame';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'frame-130',
      label: '$130',
      value: '130',
    },
    {
      id: 'frame-150',
      label: '$150',
      value: '150',
    },
    {
      id: 'frame-200',
      label: '$200',
      value: '200',
    },
    {
      id: 'all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Choose Your Frame Allowance"
        subtitle="DeltaVision offers a variety of frame and contact lens allowance options for your employees."
      />
      <RadioGroup
        label=""
        value={getFilterRangeValue(filterName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onRangeFilterChange(filterName, e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'More information on frame allowance',
          closed: 'More information on frame allowance',
        }}
        className={classes.guidelineWrapper}
        content={
          <ul className={classes.guidelineList}>
            <li className={classes.guidelineItem}>
              The frame allowance is the amount employees would have for frames once every two calendar years.{' '}
            </li>
            <li className={classes.guidelineItem}>
              Employees can choose to use the contact lens allowance in lieu of glasses.
            </li>
            <li className={classes.guidelineItem}>
              The frame allowance also determines the annual contact lens allowance. For example, if you choose $150
              frame allowance, your employees would have $150 contact lens allowance once every calendar year.
            </li>
          </ul>
        }
      />
    </div>
  );
});

export default withCriteria(VisionCriteria1, 1);
